export const WEBCALL_CUSTOM_EVENTS = {
    INIT_CALL: 'Webcall-Init-Call',
    WEBCALL_DYNAMIC_READY: 'Webcall-Dynamic-Ready',
    SET_DYNAMIC_PARAMS: 'Webcall-Set-Dynamic-Params',
    CLOSE: 'Webcall-Close',
};
